import { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { CommandeMS } from '../types';
import { getCommandeMs } from '../services/commandeMsService';

// Chargement de la commande MS prestataire (GET /subsequents/commande/{id} via le service
// autonome). Expose un refetch explicite pour rafraichir l'etat React apres une action, au lieu
// du window.location.reload() de l'ancienne infra (Candidature/Marche legacy).
export const useCommandeMsData = () => {
  const { id } = useParams<{ id: string }>();
  const [commande, setCommande] = useState<CommandeMS | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCommande = useCallback(async () => {
    if (!id) return;
    setLoading(true);
    setError(null);
    try {
      setCommande(await getCommandeMs(id));
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erreur lors du chargement');
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchCommande();
  }, [fetchCommande]);

  return { commande, setCommande, loading, error, refetch: fetchCommande };
};
